import {ACTION_ID} from '@ccxi/ccxi-apps/src/utils/modelMapper/appModelMapper/appModelConstants';
export const wamEvents = {
	sendEvents: {
		authenticate: 'authenticate',
		getCurrentDevice: 'getCurrentDevice',
		registerClient: 'registerClient',
		clientMsg: 'clientMsg'
	},
	receiveEvents: {
		sendCurrentDevice: 'sendCurrentDevice',
		clientMsg: 'clientMsg',
		clientStates: 'clientStates',
		connect: 'connect',
		error: 'error',
		connectError: 'connect_error',
		disconnect: 'disconnect',
		reconnect: 'reconnect'
	},
	connection: {
		offline: 'offline',
		online: 'online'
	},
	analytics: {
		thorDisconnect: 'thorDisconnect',
		online: 'online',
		appsFocus: 'appsFocus',
		windowFocus: 'windowFocus'
	}
};

export const progressingNames = {
	install: 'installing',
	uninstall: 'uninstalling',
	update: 'updating'
};

export const socketDisconnectReasons = {
	transportClose: 'transport close',
	pingTimeout: 'ping timeout',
	clientNameSpaceDisconnect: 'client namespace disconnect',
	serverNameSpaceDisconnect: 'server namespace disconnect',
	transportError: 'transport error'
};
export const wamMsgStatusType = {
	thorAppsState: {
		loading: 'loading',
		loadingFailed: 'loading_failed',
		loaded: 'loaded',
		appRefreshedStarted: 'appsRefreshStarted',
		cchDefault: 'cchDefault'
	},
	appsPanelInstallAvailabilityStatus: 'appsPanelInstallAvailabilityStatus',
	needConfirmation: 'needConfirmation',
	closeConfirmation: 'closeConfirmation',
	failed: 'Failed',
	waiting: 'Waiting',
	inprogress: 'inProgress',
	appIncompatible: 'AppIncompatible',
	appUnknown:	'AppUnknown',
	cancelling: 'Cancelling',
	completed: 'Completed'
};

export const clientTypes = {
	ui: 'ui',
	engine: 'engine'
};
export const clientSubType = {
	cch: 'CCHome'
};

export const thorAppsStatesCategory = {
	activeSessions: 'active_sessions',
	availableToInstall: 'available_to_install',
	availableToUpdate: 'available_updates',
	incompatible: 'incompatible',
	incompatibleWithCheckprevious: 'incompatibleWithCheckprevious',
	installed: 'installed',
	updateAllConfirmation: 'updateAllConfirmation'
};

export const thorConfirmationTypes = {
	uninstallPreferences: 'uninstallpreferences',
	fullAppUpdateConfirmationWithAdvancedOptions: 'fullappupdateconfirmationwithadvancedoptions',
	conflictingProcess: 'conflictingprocess',
	pii: 'pii',
	launchconfirmation: 'launchconfirmation',
	productunavailable: 'productunavailable',
	incompatible: 'incompatible',
	retryableError: 'retryableerror'
};

export const ccHomeCommands = {
	ccHomeToThorCommands: {
		fetchAppsListFromThor: 'getAppsAndServicesList',
		install: 'install',
		update: 'update',
		updateAll: 'updateAll',
		cancel: 'cancel',
		retry: 'retry',
		launch: 'launch',
		startTrial: 'startTrial',
		uninstall: 'uninstall'
	},
	buy: 'buy'
};

export const wamTimeouts = {
	thorConnectionTimeoutOnPageLoad: 10000,
	thorConnectionTimeoutOnCmdExecution: 10000,
	thorConnectionTimoutOnAutoRetrial: 10000,
	thorConnectionTimeoutOnWamInBackground: 180000
};

export const cchomeWamConnection = {
	onErrorReconnectAttempts : 5,
	onDisconnectReconnectAttempts: 5
};

export const cchomeThorConnection = {
	reconnectOnThorDisconnect: {
		noOfRetries: 3,
		retryInterval: 30000
	},
	thorAppsStateCheck: {
		noOfRetries: 100,
		retryInterval: 1000
	},
	reconnectDelayOnOfflineToOnline: 5000 // Not in use right now.
};

export const updateTypes = {
	patchUpdate: 'PatchUpdate',
	fullBuildUpdate: 'FullBuildUpdate',
	newVersionUpdate: 'NewVersionUpdate'
};

export const checkBoxIdentifier = {
	importPreferences: 'importpreferences',
	removeOld: 'removeold'
};

export const confirmationButtonIdentifier = {
	uninstallConfirmation: {
		keepPreferences: 'keeppreferences',
		removePreferences: 'removepreferences',
	},
	updateConfirmation: {
		update: 'update'
	},
	continue: 'continue',
	back: 'back',
	cancel: 'cancel',
	ok: 'ok',
	done: 'done'
};

export const thorEntitlementInfoType = {
	trialAvailable: 'TRIAL_AVAILABLE',
	trialNotAvailalbe: 'TRIAL_NOT_AVAILABLE',
	trialActive: 'TRIAL_ACTIVE',
	trialExpired: 'TRIAL_EXPIRED',
	licenseActive: 'LICENSE_ACTIVE',
	licenseExpired: 'LICENSE_EXPIRED',
	informationNotAvailable: 'INFORMATION_NOT_AVAILABLE',
	none: 'NONE',
	notFetched: 'NOT_FETCHED',
};

export const analyticsEvents = {
	v2ToV1: 'v2ToV1',
	onGetCurrentDevice: 'onGetCurrentDevice',
	onThorDetectionByClient: 'onThorDetectionByClient',
	onClientRecvThorAppsState : 'onClientRecvThorAppsState',
	onReceiveCurrentDevice :  'onReceiveCurrentDevice',
	onClientRegistratonWithWAM: 'onClientRegistratonWithWAM',
	onClientWAMConnection: 'onClientWAMConnection',
	onCommandProgress: 'onCommandProgress',
	onAppUnknown: 'onAppUnknown'
};

export const ctaActionIdsDenylist = [
	ACTION_ID.DISCOVER
];

export const retryableErrorToastTimeout = 8000;
export const learnMoreLinkInPIIBase = 'pii_cc';
export const thorDownloadUrlBase = 'download_cc';
export const getHelpLinkOnRetryableErrorBase = 'error_code';
export const learnMoreLinkInConflictBase = 'conflicting';
export const learnMoreLinkInUpdateBase = 'update_info';
export const inlineAttemptThroughFirstTimeInstall = {
	interval : 12000,
	iterations: 60 // iterations = minutes * 60 * 1000 / interval; default 12 minutes
};

